
// istanbul ignore file
export class UnsupportedBlockError extends Error {
    constructor(message: string) {
        super(message);
        this.name = 'UnsupportedBlockError';
        // need to set this explicitly because of a typescript issue
        // https://tinyurl.com/vutfn9vf
        Object.setPrototypeOf(this, UnsupportedBlockError.prototype);
    }
}
